import React, { useRef, useState, useCallback } from 'react';
import { Dialog, DialogActions, DialogContent, Slide } from "@mui/material";
import { Button, Divider, Grid, Typography } from '@curves/ui-base';

import { GradientColorHeader } from "@Local/Components/Dialog";
import { v4 as uuid } from 'uuid';
import { size, find, map, groupBy, concat } from 'lodash';
import { statisticsMainGroupTypeMap, statisticsSubGroupTypeMap } from "@Local/Dashboard/staticData";
import DataTypeSection from "@Local/Dashboard/Components/DataTypeSection";
const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="right" ref={ref} {...props} />;
});
const AdvancedChartFilterStatisticsDialog = (props) => {
    const {
        open: openProps = false,
        onClose: onCloseProps,
        onConfirm: onConfirmProps,
        options: optionProps = {},
        selected: selectedProps = []
    } = props;
    const defaultDataTypeSection = groupBy(selectedProps, item => `${item.mainGroupType}::${item.subGroupType}`);
    const [dialogKey, setDialogKey] = useState(uuid());
    const [clearKey, setClearKey] = useState(null);
    const sectionRef = useRef({});
    const {
        memberGroupOptions = [],
        nonMembershipGroupOptions = [],
        coachGroupOptions = []
    } = optionProps || {};
    const handleClickReset = () => {
        setClearKey('RESET');
        setDialogKey(uuid());
    };
    const handleClickClearAll = () => {
        setClearKey('ALL');
        setDialogKey(uuid());
    };
    const handleConfirm = () => {
        let result = [];
        concat(memberGroupOptions, nonMembershipGroupOptions, coachGroupOptions)
            .forEach((option) => {
                const { mainGroupType, subGroupType } = option;
                const key = `${mainGroupType}::${subGroupType}`;
                result = result.concat(sectionRef.current[key].getResult());
            });
        onConfirmProps && onConfirmProps(result);
        onCloseProps && onCloseProps();
    };
    const renderSection = useCallback(
            (options, mainType, subType) => {
                const currentOption = find(options, { mainGroupType: mainType, subGroupType: subType });
                const {
                    mainGroupType,
                    subGroupType,
                    mainGroupTypeText,
                    subGroupTypeText,
                    dataTypeOptions
                } = currentOption;
                const key = `${mainGroupType}::${subGroupType}`;
                const label = subGroupTypeText ?? `全${mainGroupTypeText}統計項目`;
                const defaultSelected = clearKey === 'ALL' ? [] : map(defaultDataTypeSection[key] || [], 'dataType');
                return <DataTypeSection key={`data-type-section-${key}_${dialogKey}`}
                                        label={label}
                                        mainGroupType={mainGroupType}
                                        subGroupType={subGroupType}
                                        dataTypeOptions={dataTypeOptions}
                                        defaultSelected={defaultSelected}
                                        ref={(el) => (sectionRef.current[key] = el)}
                />;
            },
            // eslint-disable-next-line
            [dialogKey, clearKey, selectedProps]
        )
    ;
    return (
        <Dialog open={openProps} TransitionComponent={Transition} fullScreen>
            <GradientColorHeader onClose={onCloseProps}>選擇查詢欄位</GradientColorHeader>
            <DialogContent>
                {size(memberGroupOptions) > 0 && (
                    <Grid container spacing={5}>
                        <Grid item xs={4}>
                            <Typography variant={'h3'} className={'text-center'}>會籍</Typography>
                            <Divider className="my-2" />
                            {renderSection(memberGroupOptions, statisticsMainGroupTypeMap.membership, null)}
                            <Typography variant={'h3'} className={'text-center'}>服務</Typography>
                            <Divider className="my-2" />
                            {renderSection(memberGroupOptions, statisticsMainGroupTypeMap.clubService, null)}
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant={'h3'} className={'text-center'}>顧客製造</Typography>
                            <Divider className="my-2" />
                            <Grid container spacing={5}>
                                <Grid item xs={6}>
                                    {renderSection(memberGroupOptions, statisticsMainGroupTypeMap.customerAcquisition, statisticsSubGroupTypeMap.agp)}
                                    <br />
                                    {renderSection(memberGroupOptions, statisticsMainGroupTypeMap.customerAcquisition, statisticsSubGroupTypeMap.calls)}
                                    <br />
                                    {renderSection(memberGroupOptions, statisticsMainGroupTypeMap.customerAcquisition, statisticsSubGroupTypeMap.join)}
                                </Grid>
                                <Grid item xs={6}>
                                    {renderSection(memberGroupOptions, statisticsMainGroupTypeMap.customerAcquisition, statisticsSubGroupTypeMap.apo)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {size(nonMembershipGroupOptions) > 0 && (
                    <Grid container spacing={5}>
                        <Grid item xs={6}>
                            <Typography variant={'h3'} className={'text-center'}>HC</Typography>
                            <Divider className="my-2" />
                            {renderSection(nonMembershipGroupOptions, statisticsMainGroupTypeMap.nonMembership, statisticsSubGroupTypeMap.healthcareCycle)}
                            <br />
                            {renderSection(nonMembershipGroupOptions, statisticsMainGroupTypeMap.nonMembership, statisticsSubGroupTypeMap.healthcareBuyout)}
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'h3'} className={'text-center'}>商品</Typography>
                            <Divider className="my-2" />
                            {renderSection(nonMembershipGroupOptions, statisticsMainGroupTypeMap.nonMembership, statisticsSubGroupTypeMap.product)}
                        </Grid>
                    </Grid>
                )}
                {size(coachGroupOptions) > 0 && (
                    <Grid container spacing={5}>
                        <Grid item xs={12}>
                            <Typography variant={'h3'} className={'text-center'}>教練</Typography>
                            <Divider className="my-2" />
                            {renderSection(coachGroupOptions, statisticsMainGroupTypeMap.coach, null)}
                        </Grid>
                    </Grid>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClickReset} color="primary">
                    重置選項
                </Button>
                <Button variant="outlined" onClick={handleClickClearAll} color="primary">
                    清除全部
                </Button>
                <Button variant="contained" color="primary" onClick={handleConfirm}>
                    確認
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default AdvancedChartFilterStatisticsDialog;